module.exports = __webpack_public_path__ + "static/media/HeadphoneCoreCheck.52982fae.png";